<app-upgrade-prompt
  [upgradeUrl]="upgradeUrl"
  (primaryClick)="onViewPlans()"
  (dismiss)="onDismiss()"
></app-upgrade-prompt>
